import { createSelector } from 'reselect';

const allIds = (state) => state.entities.campaign.allIds;
const byId = (state) => state.entities.campaign.byId;
const current = (state) => state.entities.campaign.current;

export const getAllCampaigns = createSelector(
  [ byId, allIds ],
  (campaigns, ids) => {
    return ids.map(id => campaigns[id]);
  }
);

export const getCurrentCampaign = createSelector(
  [ byId, current ],
  (campaigns, id) => {
    const currentCampaign = campaigns[id] || {};
    return {
      ...currentCampaign,
      previousCampaign: campaigns[currentCampaign.previousCampaign] || {},
      nextCampaign: campaigns[currentCampaign.nextCampaign] || {},
    };
  }
);


// WEBPACK FOOTER //
// ./src/modules/campaign/campaign.selectors.js